import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Answer, Link } from '../../types/api';
import { Application, Document, Question } from './types';

export const FETCH_APPLICATION = 'FETCH_APPLICATION';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAIL = 'FETCH_APPLICATION_FAIL';
export const POLICY_ACTION = 'POLICY_AGREEMENT_CHANGED';
export const PUT_POLICY_ACCEPT = 'PUT_POLICY_ACCEPT';
export const PUT_POLICY_ACCEPT_SUCCESS = 'PUT_POLICY_ACCEPT_SUCCESS';
export const SAVE_ANSWER = 'SAVE_ANSWER';
export const SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';
export const SAVE_DOCUMENT = 'SAVE_DOCUMENT';
export const SAVE_DOCUMENT_SUCCESS = 'SAVE_DOCUMENT_SUCCESS';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';
export const SHOW_QUESTION = 'SHOW_QUESTION';
export const NO_QUESTION = 'NO_QUESTION';
export const RETRY_ANSWER = 'RETRY_ANSWER';
export const SUBMIT_APPLICATION = 'SUBMIT_APPLICATION';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';

export type ApplicationAction = ShowQuestion | NoQuestion | RetryAnswer | AxiosResponseAction | PolicyAgreementChanged;

export interface AxiosRequestAction {
    type:
        | typeof FETCH_APPLICATION
        | typeof SUBMIT_APPLICATION
        | typeof SAVE_ANSWER
        | typeof SAVE_DOCUMENT
        | typeof DELETE_DOCUMENT
        | typeof PUT_POLICY_ACCEPT;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface AxiosResponseAction {
    type:
        | typeof FETCH_APPLICATION_SUCCESS
        | typeof FETCH_APPLICATION_FAIL
        | typeof SUBMIT_APPLICATION_SUCCESS
        | typeof SAVE_ANSWER_SUCCESS
        | typeof SAVE_DOCUMENT_SUCCESS
        | typeof DELETE_DOCUMENT_SUCCESS
        | typeof PUT_POLICY_ACCEPT_SUCCESS;
    payload: AxiosResponse;
    meta: {
        previousAction: any;
    };
}

export interface ShowQuestion {
    type: typeof SHOW_QUESTION;
    payload: {
        question: Question;
    };
}

export interface NoQuestion {
    type: typeof NO_QUESTION;
    payload: {};
}

export interface RetryAnswer {
    type: typeof RETRY_ANSWER;
    payload: {
        answer: Answer;
    };
}

export interface PolicyAgreementChanged {
    type: typeof POLICY_ACTION;
    payload: {
        agree: boolean;
        clicked: boolean;
    };
}

export const fetchApplication = (applicationId: string): AxiosRequestAction => {
    const fetchApplicationAction: AxiosRequestAction = {
        type: FETCH_APPLICATION,
        payload: {
            request: {
                url: `/candidates/${applicationId}`
            }
        }
    };
    return fetchApplicationAction;
};

export const saveAnswer = (answer: Answer, link: Link): AxiosRequestAction => {
    return {
        type: SAVE_ANSWER,
        payload: {
            request: {
                url: link.href.replace('{answerId}', answer.id),
                method: 'put',
                data: answer
            }
        }
    };
};

export const onRetry = (answer: Answer): RetryAnswer => ({
    type: RETRY_ANSWER,
    payload: {
        answer
    }
});

export const showQuestion = (question: Question): ShowQuestion => ({
    type: SHOW_QUESTION,
    payload: {
        question
    }
});

export const noQuestion = (): NoQuestion => ({
    type: NO_QUESTION,
    payload: {}
});

export const submitApplication = (application: Application): AxiosRequestAction => {
    const url = application._links === undefined ? '' : application._links.put_submit.href;
    return {
        type: SUBMIT_APPLICATION,
        payload: {
            request: {
                url,
                method: 'put'
            }
        }
    };
};

export const onDocumentUploaded = (document: Document, link: Link) => {
    return {
        type: SAVE_DOCUMENT,
        payload: {
            request: {
                url: link.href.replace('{documentId}', document.id),
                method: 'put',
                data: document
            }
        }
    };
};

export const deleteDocument = (document: Document) => {
    return {
        type: DELETE_DOCUMENT,
        payload: {
            request: {
                url: document._links!.self.href,
                method: 'delete'
            },
            id: document.id
        }
    };
};

export const policyAction = (agree: boolean, clicked: boolean) => {
    return {
        type: POLICY_ACTION,
        payload: {
            agree,
            clicked
        }
    };
};

export const putPolicyAccept = (link: Link): AxiosRequestAction => {
    return {
        type: PUT_POLICY_ACCEPT,
        payload: {
            request: {
                url: link.href,
                method: 'put'
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/scenes/candidate/actions.ts